import {priceM2Format} from "@pg-mono/string-utils";

import {IRegionReportPrice} from "../../../../region/types/IRegionReportPrice";
import {PricesInsightBox} from "../../atoms/PricesInsightBox";
import {RoomsFilter} from "../../constants/rcn_rooms_filter";
import {formatMonthLocativePhrase} from "../../utils/format_month_label";
import {getFlatTypeGenitivePluralLabel} from "../../utils/get_flat_type_genitive_label";
import {TrendInsight} from "../../utils/get_trend_insight";
import {getPercentMeaning, getPercentTrendVerb} from "../../utils/percents_handling_helpers";

interface Props {
    insight: TrendInsight;
    region: IRegionReportPrice;
    rooms: RoomsFilter;
}

export const PricesTrendInsight = (props: Props) => {
    const {insight, region, rooms} = props;

    return (
        <PricesInsightBox>
            {insight.avg && (
                <>
                    Średnie ceny {getFlatTypeGenitivePluralLabel(rooms)} {region.name_declension_where} w stanie deweloperskim{" "}
                    {formatMonthLocativePhrase(insight.avg.date)} wynoszą {priceM2Format(insight.avg.priceM2)}, co oznacza{" "}
                    {insight.avg.yoyPercent === 0 ? "brak zmian" : `${getPercentMeaning(insight.avg.yoyPercent)} rzędu ${Math.abs(insight.avg.yoyPercent)}%`}{" "}
                    r/r oraz{" "}
                    {insight.avg.momPercent === 0
                        ? "brak zmian"
                        : `${getPercentMeaning(insight.avg.momPercent)} rzędu ${Math.abs(insight.avg.momPercent).toString().replace(".", ",")}%`}{" "}
                    m/m.{" "}
                </>
            )}
            {insight.median && (
                <>
                    Mediana, czyli cena środkowa, wynosi {priceM2Format(insight.median.priceM2)} i{" "}
                    {insight.median.yoyPercent === 0
                        ? "nie zmienia się"
                        : `${getPercentTrendVerb(insight.median.yoyPercent)} o ${Math.abs(insight.median.yoyPercent)}%`}{" "}
                    r/r.{" "}
                </>
            )}
        </PricesInsightBox>
    );
};
import {priceM2Format} from "@pg-mono/string-utils";

import {IRegionReportPrice} from "../../../../region/types/IRegionReportPrice";
import {PricesInsightBox} from "../../atoms/PricesInsightBox";
import {RoomsFilter} from "../../constants/rcn_rooms_filter";
import {formatMonthLocativePhrase} from "../../utils/format_month_label";
import {getFlatTypeGenitivePluralLabel} from "../../utils/get_flat_type_genitive_label";
import {TrendInsight} from "../../utils/get_trend_insight";
import {getPercentMeaning, getPercentTrendVerb} from "../../utils/percents_handling_helpers";

interface Props {
    insight: TrendInsight;
    region: IRegionReportPrice;
    rooms: RoomsFilter;
}

export const PricesTrendInsight = (props: Props) => {
    const {insight, region, rooms} = props;

    return (
        <PricesInsightBox>
            {insight.avg && (
                <>
                    Średnie ceny {getFlatTypeGenitivePluralLabel(rooms)} {region.name_declension_where} w stanie deweloperskim{" "}
                    {formatMonthLocativePhrase(insight.avg.date)} wynoszą {priceM2Format(insight.avg.priceM2)}, co oznacza{" "}
                    {insight.avg.yoyPercent === 0 ? "brak zmian" : `${getPercentMeaning(insight.avg.yoyPercent)} rzędu ${Math.abs(insight.avg.yoyPercent)}%`}{" "}
                    r/r oraz{" "}
                    {insight.avg.momPercent === 0
                        ? "brak zmian"
                        : `${getPercentMeaning(insight.avg.momPercent)} rzędu ${Math.abs(insight.avg.momPercent).toString().replace(".", ",")}%`}{" "}
                    m/m.{" "}
                </>
            )}
            {insight.median && (
                <>
                    Mediana, czyli cena środkowa, wynosi {priceM2Format(insight.median.priceM2)} i{" "}
                    {insight.median.yoyPercent === 0
                        ? "nie zmienia się"
                        : `${getPercentTrendVerb(insight.median.yoyPercent)} o ${Math.abs(insight.median.yoyPercent)}%`}{" "}
                    r/r.{" "}
                </>
            )}
        </PricesInsightBox>
    );
};
